import React from "react";

import useAbility from "../../hooks/useAbility";
import UsageAdmin from "../analytics/usageAnalytics/UsageAdmin";

import type { JSX } from "react";

function Insights(): JSX.Element | null {
  const { hasOrgaAbility } = useAbility();

  if (!hasOrgaAbility()) return null;

  return <UsageAdmin />;
}

export default Insights;
